import { RadioGroup } from './radio-group';

export default RadioGroup;
